import config from '@/config';
export const trackGaEvent = (eventCategory, eventAction, eventLabel, eventValue) => {
    // Refer to this doc: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#events
    if (config.GOOGLE_ANALYTICS_ID && ga) {
        ga('send', 'event', eventCategory, eventAction, eventLabel || '', eventValue || 1);
    }
    else {
        console.table({
            'GA Info': '[Only in Dev Mode]',
            eventCategory,
            eventAction,
            eventLabel,
            eventValue,
        });
    }
    // To test, add these line, in environment configurations:
    // googleAnalyticId: 'UA-115177999-2',
};
export const trackGaPageView = (pageName) => {
    // Refer to this doc: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#events
    if (config.GOOGLE_ANALYTICS_ID && ga) {
        ga('set', 'page', pageName || '');
        ga('send', 'pageview');
    }
    // To test, add these line, in environment configurations:
    // googleAnalyticId: 'UA-115177999-2',
};
